import styled from 'styled-components'

const LicenseHead = styled.div`
  padding: 12px 32px;
  border-bottom: 1px solid var(--theme-colors-global-grey-grey300);
`

const LicenseNumber = styled.p`
  color: var(--theme-colors-global-grey-grey900);
  font: var(--theme-typography-bodyS-regular);
  padding-left: 26px;
`

export const s = { LicenseHead, LicenseNumber }
